import factory, { factoryScaledToFit }  from './icon';
import Svg16x16 from './glyphs/MapPin_16x16.svg';
import Svg24x24 from './glyphs/MapPin_24x24.svg';

export const Location16x16 = factory(Svg16x16, 16, 16);
export const Location24x24 = factory(Svg24x24, 24, 24);

export const LocationScaled = factoryScaledToFit(Svg24x24, true);
